import {
  CalendarEventWriteResult,
  RespondToCalendarEventInput,
} from '@griply/types';

import { FirebaseHttpsCallableFactory } from '../types/firebase-functions';

export type RespondToExternalCalendarEventOptions<TFunctions> = {
  functions: TFunctions;
  httpsCallable: FirebaseHttpsCallableFactory<TFunctions>;
  payload: RespondToCalendarEventInput;
};

// The callable this binds to is not deployed yet — the RSVP control is built against the
// agreed name and errors until the backend ships it. Confirm the name before release.
export const respondToExternalCalendarEvent = async <TFunctions>(
  options: RespondToExternalCalendarEventOptions<TFunctions>,
): Promise<CalendarEventWriteResult> => {
  const { functions, httpsCallable, payload } = options;
  const callable = httpsCallable<
    RespondToCalendarEventInput,
    CalendarEventWriteResult
  >(functions, 'externalCalendars-respondToEvent');

  const { data } = await callable(payload);

  return data;
};
